import React, { useMemo } from 'react';
import { Table, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import qs from 'qs';

import Tooltip from '../../../../../components/Tooltip';
import BalanceCell from './BalanceCell';

import { generateTableBody, generateTableHead } from '../../helpers';

const ProvidersTable = ({ items, access, onEdit }) => {
  const history = useHistory();
  const location = useLocation();
  const headers = useMemo(() => generateTableHead(access), [access]);

  const queryString = qs.parse(location.search.slice(1));

  const onSortBalance = (e) => {
    e.preventDefault();
    const searchParam = new URLSearchParams(queryString);
    switch (queryString?.sort) {
    case 'balance': {
      searchParam.set('sort', 'balance-desc');
      break;
    }
    default: {
      searchParam.set('sort', 'balance');
    }
    }
    history.push({
      pathname: '/settings/providers',
      search: `?${searchParam.toString()}`,
    });
  }

  const getSortIcon = useMemo(
    () => {
      if (queryString.sort === 'balance-desc') {
        return faSortDown;
      }
      if (queryString.sort === 'balance') {
        return faSortUp;
      }
      return faSort;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [queryString],
  );

  return (
    <Table className="mb-30">
      <thead>
        <tr>
          {headers?.map((head, index) => {
            if (head?.code === 'balance') {
              return (
                <th key={head.title + index} className={head.class} {...head.attrs}>
                  <a href="# " onClick={onSortBalance}>
                    {head?.title}
                    {' '}
                    <FontAwesomeIcon icon={getSortIcon} />
                  </a>
                </th>
              )
            }
            return (
              <th key={head.title + index} className={head.class} {...head.attrs}>
                {head.title}
              </th>
            )
          })}
        </tr>
      </thead>

      <tbody>
        {items?.map((item) => (
          <tr
            key={item.id}
            className={classNames('', {
              grey: !item?.active,
              wighlight: item?.wighlight,
            })}
            style={{ backgroundColor: item?.wighlight_color }}
          >
            {generateTableBody(item, access)?.map((element) => {
              switch (element.type) {
              case 'event_low_balance':
                return (
                  <td key={element.type} className={element.class} {...element.attrs}>
                    {element.value && item.type === 1 && item?.balance_is_available ? (
                      <Tooltip placement="top" tooltipClass="tooltip__top" text={element.value?.title}>
                        <span
                          className={classNames('fas fa-bell event-balance', {
                            enable: element.value?.enable,
                          })}
                        />
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </td>
                );

              case 'balance':
                if (!access?.providers_balance) {
                  return <td key={element.type} className={element.class} {...element.attrs} />;
                }
                return <BalanceCell key={element.type} element={element} item={item} />;

              case 'actions':
                return (
                  <td key={element.type} className={element.class} {...element.attrs}>
                    <Button bsSize="xsmall" className="pull-right" onClick={() => onEdit(item)}>
                      Edit
                    </Button>
                  </td>
                );

              default:
                return (
                  <td key={element.type} className={element.class} {...element.attrs}>
                    {element.value}
                  </td>
                );
              }
            })}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

ProvidersTable.propTypes = {
  items: PropTypes.array,
  access: PropTypes.object,
  onEdit: PropTypes.func,
};

export default ProvidersTable;
